define(function (require) {
    var app = require('system.app');
    
    return {
        /**
         * Display content from the URL in the dialog window
         * 
         * @param {strint} url URL of the dialog
         * @param {object} data data which comes with request. Default is null;
         * @param {string} requestType "post" or "get". Default is "get";
         * @returns {object Promise<>} result result from "app.component.compile"
         * @rejects {Error} error
         */
        show: function (url, data, requestType) {
            data = data || null;
            requestType = (typeof requestType === 'undefined')? 'get' : requestType;
            
            return app.http[requestType](url, data, 'html').then(function (page) {
                return app.component.compile($(page).appendTo('body'), true);
            });
        }
    }
});